import { render, staticRenderFns } from "./PollManage.vue?vue&type=template&id=4caf239e&scoped=true"
import script from "./PollManage.vue?vue&type=script&lang=js"
export * from "./PollManage.vue?vue&type=script&lang=js"
import style0 from "./PollManage.vue?vue&type=style&index=0&id=4caf239e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caf239e",
  null
  
)

export default component.exports